import React from 'react'
import { Tooltip, TooltipProps } from 'src/antd'

export type WHTooltipProps = { title: string | React.ReactNode } & TooltipProps

export const WHTooltip = ({
  title,
  children,
  ...restProps
}: WHTooltipProps) => {
  return (
    <Tooltip title={title} autoAdjustOverflow placement="bottom" {...restProps}>
      {children}
    </Tooltip>
  )
}
